import {GET_STATEMENTS_REQUEST, 
    GET_STATEMENTS_SUCCESS, 
    GET_STATEMENTS_ERROR} from '../actions/type';

const initialState = {
    loading: null,
    error: null,
    data: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state=initialState, action) => {
    switch(action.type) {
        case GET_STATEMENTS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case GET_STATEMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data
            }
        case GET_STATEMENTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        default:
            return state;
    }
}